import { Fragment, type ReactNode } from 'react'
import s from './Prose.module.css'

/**
 * A few paragraphs of plain markdown: paragraphs, `- ` lists, **bold** and `code`. For words that live in files,
 * like a skill's "For the founder" section. Never pass it HTML: it is drawn as text, so nothing in it can run.
 */
export function Prose(props: { markdown: string }) {
  const blocks = props.markdown.trim().split(/\n\s*\n/)
  return (
    <div className={s.prose}>
      {blocks.map((block, i) => {
        const lines = block.split('\n')
        if (lines.every((l) => /^\s*[-*] /.test(l) || /^\s{2,}\S/.test(l))) {
          const items: string[] = []
          for (const l of lines) {
            if (/^\s*[-*] /.test(l)) items.push(l.replace(/^\s*[-*] /, ''))
            else items[items.length - 1] += ` ${l.trim()}`
          }
          return (
            <ul key={i}>
              {items.map((item, j) => (
                <li key={j}>{inline(item)}</li>
              ))}
            </ul>
          )
        }
        return <p key={i}>{inline(lines.join(' '))}</p>
      })}
    </div>
  )
}

/** **bold**, `code` and > quote markers, as React text. */
function inline(text: string): ReactNode {
  const parts = text.replace(/^>\s?/, '').split(/(\*\*[^*]+\*\*|`[^`]+`)/g)
  return parts.map((p, i) => {
    if (p.startsWith('**') && p.endsWith('**')) return <strong key={i}>{p.slice(2, -2)}</strong>
    if (p.startsWith('`') && p.endsWith('`')) return <code key={i}>{p.slice(1, -1)}</code>
    return <Fragment key={i}>{p}</Fragment>
  })
}
